import { Column, Row } from "@react-email/components";
import { defaultStyles } from "./defaultStyles";

export const AddressSection = ({ address }: { address: string | null }) => {
  if (!address) {
    return null;
  }

  return (
    <Row style={defaultStyles.addressRow}>
      <Column align="center">
        <span>{address}</span>
      </Column>
    </Row>
  );
};
